// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"666":"a633cf55","736":"9a11f7db","811":"1677af37"}[chunkId] + ".chunk.css";
};